export const JSON_Bank_Check_Status1 = {
    "code":"0x0200",
    "message":"Record fetched successfully.",
    "status":"SUCCESS",
    "data":{
        "requestId":"VBNK282988243721545177FD",
        "currentStatus":"FOUND",
        "response":{
            "accountNumber":"919900000000",
            "ifscCode":"PYTM0123456",
            "fullName":"AMITGUPTA"
        }
    }
};

export const JSON_Bank_Check_Status2 = {
    "code":"0x0200",
    "message":"Record fetched successfully.",
    "status":"SUCCESS",
    "data":{
        "requestId":"VBNK282988243721545177FD",
        "currentStatus":"NOT_FOUND",
    }
}

export const JSON_Bank_Check_Status3 = {
    "code": "0x0202",
    "status": "FAILURE",
    "message": "Failure",
    "data":{
            "requestId":"VBNK282988243721545177FD",
            "currentStatus":"FAILED"
        }
    
}
